import { Tooltip } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import { useIntroducerData } from 'contexts/IntroducerData/IntroducerData.context';
import { useNumberFormat } from 'hooks/useNumberFormat';
import styles from './FlexiKreditFeatures.module.css';

const MONTHLY_INTEREST = 0.01;
const WITHDRAWAL_FEE = 0;
const INITIAL_COMMISSION = 0.03;
const RECURRING_COMMISSION = 0.015;
const INITIAL_COMMISSION_MAX_PAYOUT = 100000;
const REDUCED_INITIAL_COMMISSION = 0.015;

const HIDE_COMMISSION_HEADQUARTERS = ['Commerzbank', 'CapeTec'];
const HIDE_COMMISSION_INTRODUCER_IDS = ['44198d7a-c56f-433f-a88e-08fe40ab9d78']; // Broker Account: 682

export const useFlexiKreditFeaturesTable = () => {
  const { formatCurrency, formatPercentage } = useNumberFormat();
  const { introducer, introducerCompany } = useIntroducerData();

  const hideCommissionRows =
    HIDE_COMMISSION_HEADQUARTERS.includes(
      introducerCompany?.headquarters_name ?? '',
    ) || HIDE_COMMISSION_INTRODUCER_IDS.includes(introducer?.id ?? '');

  const monthlyInterestRate = formatPercentage(MONTHLY_INTEREST);
  const withdrawalFee = formatPercentage(WITHDRAWAL_FEE);
  const initialCommission = formatPercentage(INITIAL_COMMISSION);
  const recurringCommission = formatPercentage(RECURRING_COMMISSION);
  const initialCommissionMaxPayout = formatCurrency(
    INITIAL_COMMISSION_MAX_PAYOUT,
  );
  const reducedCommissionFrom = formatCurrency(
    INITIAL_COMMISSION_MAX_PAYOUT + 1,
  );
  const reducedInitialCommission = formatPercentage(REDUCED_INITIAL_COMMISSION);

  const data = [
    {
      feature: t`12, 24, 36, 48 and 60 months`,
      monthlyInterestRate: t`from ${monthlyInterestRate}*`,
      withdrawalFee,
      ...(!hideCommissionRows && { initialCommission, recurringCommission }),
    },
  ];

  return {
    data,
    hideCommissionRows,
    labels: {
      feature: t`Product description`,
      monthlyInterestRate: (
        <div className={styles.tooltipRow}>
          {t`30 day interest rate`}
          <Tooltip
            content={t`Please note that interest is calculated daily on your customer's outstanding principal. Your payment date and interest payment may vary.`}
          />
        </div>
      ),
      withdrawalFee: t`Withdrawal fee`,
      ...(!hideCommissionRows && {
        initialCommission: (
          <div className={styles.tooltipRow}>
            {t`Initial commission`}
            <Tooltip
              content={t`Applies to new customers up to ${initialCommissionMaxPayout} payout amount (${reducedInitialCommission} from ${reducedCommissionFrom})`}
            />
          </div>
        ),
        recurringCommission: (
          <div className={styles.tooltipRow}>
            {t`Recurring commission`}
            <Tooltip content={t`Applies to existing customers`} />
          </div>
        ),
      }),
    },
  };
};
